import React from 'react';
import T from 'prop-types';
// components
import { FormattedMessage } from 'react-intl';
// hooks
import { useDropdownActions } from 'hooks/useDropdownContext';
// utils
import cn from 'classnames';
// styles
import './ManageFieldsButton.scss';

// Entry point for Manage Visible Fields. A compact three-dots trigger that opens
// the shared context dropdown with a link to the column management page for the
// given table (`name` matches a key from tableNames / columnsConfig).
const ManageFieldsButton = ({ name, className }) => {
  const { openDropdown } = useDropdownActions();

  const handleOpen = (e) => {
    openDropdown(e, [
      {
        label: <FormattedMessage id="general.btn.manageFields" />,
        url: `/barnsheets/manage-columns?name=${name}`,
      },
    ]);
  };

  return (
    <i
      data-name={`manage-fields-${name}`}
      className={cn('fa fa-dots-three-horizontal', 'ManageFieldsButton', className)}
      onClick={handleOpen}
    />
  );
};

ManageFieldsButton.propTypes = {
  name: T.string.isRequired,
  className: T.string,
};

export default ManageFieldsButton;
